import React, { useState } from "react";
import { getLanguageSet, template } from "../Locales";
import { casing } from "./contextHelper";

const UserLanguageContext = React.createContext();
export default UserLanguageContext;

export function UserLanguageContextWrapper(props) {
  const [localeSet, setLocaleSet] = useState(getLanguageSet());
  const setUserLocaleContext = (value) => {
    const newLocalSet = getLanguageSet(value);
    setLocaleSet(newLocalSet);
  };

  return (
    <UserLanguageContext.Provider
      value={{
        localeSet,
        setUserLocaleContext,
        casing,
        template,
      }}
    >
      {props.children}
    </UserLanguageContext.Provider>
  );
}



// WEBPACK FOOTER //
// ../nx-components/src/ContextWrappers/UserLanguageContext.jsx